import React from "react";
import { FaUserTie, FaUsers, FaBriefcase, FaCheckCircle } from "react-icons/fa";
import '../App.css';
const dashboards = [
  {
    id: 1,
    name: "Job Seeker",
    icon: <FaUserTie />,
    features: [
      "One-click applications with smart profile - no repetitive forms",
      "Live application tracking with real-time status updates",
      "Actionable feedback on rejections to improve performance",
      "AI-powered job matching based on skills and goals",
      "Automated interview scheduling with availability sync",
      "Complete profile shared instantly with recruiters when updated",
    ],
  },
  {
    id: 2,
    name: "Recruiter",
    icon: <FaUsers />,
    features: [
      "Smart talent pool with complete control over candidate selection",
      "AI-generated job descriptions with dual posting capabilities",
      "Auto-staging through hiring pipeline based on decisions",
      "One-click candidate submissions to hiring managers",
      "AI-powered offer generation in under a minute",
      "Native scheduling and communication tools",
      "Real-time collaboration with hiring managers",
    ],
  },
  {
    id: 3,
    name: "Hiring Manager",
    icon: <FaBriefcase />,
    features: [
      "Centralized candidate dashboard with all submissions",
      "AI-generated candidate summaries for faster screening",
      "Smart match scores to identify top candidates quickly",
      "Real-time collaboration with recruiters and team members",
      "AI-assisted feedback generation with minimal effort",
      "Share availability preferences accessed by recruiters",
    ],
  },
];

const DashboardFeatures = () => {
  return (
    <div className="dashboard-section">
              <h2 className="dashboard-title">One Platform, Three Powerful Experiences</h2>
        <p style={{ textAlign: 'center', fontSize: '1.4rem', color: '#666', marginBottom: '50px', maxWidth: '900px', margin: '0 auto 50px auto', lineHeight: '1.6' }}>
          Each role has unique needs and workflows. Our dedicated workspaces ensure every team member—from job seekers to hiring managers—gets exactly the tools and information they need.
        </p>
      <div className="dashboard-container">
        {dashboards.map((dashboard) => (
          <div key={dashboard.id} className="dashboard-card">
            <div className="dashboard-icon">{dashboard.icon}</div>
            <h3 className="dashboard-name" style={{justifyItems:"center"}}>{dashboard.name}</h3>
            <ul className="dashboard-features">
              {dashboard.features.map((feature, index) => (
                <li key={index} className="feature-item">
                  <FaCheckCircle className="feature-icon" /> {feature}
                </li>
              ))}
            </ul>
            <div style={{ marginTop: '20px', textAlign: 'center' }}>
              <button 
                style={{
                  background: '#d1bd21',
                  color: 'black',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease'
                }}
                onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                onMouseOut={(e) => e.target.style.transform = 'translateY(0px)'}
                onClick={() => {
                  if (dashboard.name === "Job Seeker") {
                    window.location.href = '/for-job-seekers';
                  } else if (dashboard.name === "Recruiter") {
                    window.location.href = '/for-recruiters';
                  } else if (dashboard.name === "Hiring Manager") {
                    window.location.href = '/';
                  }
                }}
              >
                Learn More →
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardFeatures;
